import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  root: {},
  textField: {
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.grey[200],
      border: `1px solid ${theme.palette.grey[50]}`,
      boxSizing: 'border-box',
      borderRadius: '4px',
      lineHeight: '24px',
      transition: 'background-color 0.15s linear',
      overflow: 'hidden',

      '&:hover': {
        border: `1px solid ${theme.palette.grey[300]}`,
      },
    },
    '& .MuiSelect-select': {
      padding: '7px 16px !important',
      backgroundColor: theme.palette.grey[200],
    },
    '&.focused .MuiInputBase-root': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
    '&.viewMode .MuiInputBase-root, &.viewMode .MuiSelect-root': {
      border: 'none',
      backgroundColor: 'transparent',
      height: 'unset',
      padding: '0 !important',
      color: theme.palette.text.primary,
      fontSize: '14px',

      '& svg': {
        display: 'none',
      },

      '& input, & textarea': {
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
        fontSize: '14px',
        padding: '0 !important',
        textAlign: 'start',
      },
    },
    '&.error .MuiInputBase-root': {
      border: `1px solid ${theme.palette.error.main}`,
    },
    '& .MuiFilledInput-root': {
      backgroundColor: 'unset',
    },
    '& .MuiFilledInput-multiline': {
      padding: '7px 16px',
      width: '100%',
    },
    '& .MuiInputAdornment-positionStart': {
      paddingLeft: '8px',

      '& + input': {
        paddingLeft: '0',
      },
    },
    '& .MuiInputAdornment-positionEnd': {
      paddingRight: '8px',
    },
    '& label + .MuiInput-formControl': {
      marginTop: '22px',
    },
    '& label': {
      fontWeight: '500',
      fontStyle: 'normal',
      color: theme.palette.grey[600],
      fontSize: '14px',
      padding: '4px 0',
      transform: 'none',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
    },
    '& input, & .MuiFilledInput-multiline': {
      padding: '7px 16px',
      fontSize: '14px',
      width: '100%',
      lineHeight: '24px',
      backgroundColor: theme.palette.grey[200],
      boxSizing: 'border-box',
      height: '38px',
      borderRadius: '4px',
      fontWeight: '500',
    },
    '& textarea': {
      fontSize: '14px',
      padding: '0px 16px',
      fontWeight: '500',
      backgroundColor: theme.palette.grey[200],
    },
  },

  viewModeWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
